'use client'
import { useParams } from 'next/navigation'
import { useEffect, useRef, useState } from 'react'

import useHash from '@/shared/hooks/useHash'

import type { HASH_KEY_TYPE } from '@/enums/map'

function useHashChange(hashKey: HASH_KEY_TYPE) {
  const params = useParams()
  const { getHashByKey } = useHash()
  const [changedHashValues, setChangedHashValues] = useState(getHashByKey(hashKey))
  const prevHash = useRef(changedHashValues)

  useEffect(() => {
    const hash = getHashByKey(hashKey)
    if (prevHash.current !== hash) {
      prevHash.current = hash
      setChangedHashValues(hash)
    }
  }, [params])

  useEffect(() => {
    const onChangeHashValues = () => {
      getHashByKey(hashKey)
      setChangedHashValues(getHashByKey(hashKey))
    }
    window.addEventListener('hashchange', onChangeHashValues)
    return () => {
      window.removeEventListener('hashchange', onChangeHashValues)
    }
  }, [])

  return changedHashValues
}

export default useHashChange
